import { NgModule } from "@angular/core";
import { AccountingFoldersService } from "./services/accounting-folders.service";
import { HttpClientModule } from "@angular/common/http";

@NgModule({
    providers: [
      AccountingFoldersService,
    ],
    imports: [
      HttpClientModule,
    ]
})
export class AccountingFoldersModule {}